/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_progress, {
		appearance: 'none',
		width: '100%',
		height: '0.5rem',
		border: {
			radius: '9999px',
			width: 0,
		},
		background: {
			color: $bog_builderui_tokens.field,
		},
		color: $bog_builderui_tokens.control,
	} )
}
